import React, { useState, useEffect } from 'react';
import { AlertTriangle, X, Package } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import axios from 'axios';

// URL centralizado que funciona em produção mesmo com .env errado
import { getBackendUrl } from '../utils/config';
const API_URL = getBackendUrl();

const AlertaValidadesHoje = () => {
  const [show, setShow] = useState(false);
  const [validadesHoje, setValidadesHoje] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Aguardar um pouco para garantir que o token já foi carregado
    const timer = setTimeout(() => {
      // Verificar se o alerta já foi mostrado HOJE (não apenas nesta sessão)
      const alertaJaMostrado = localStorage.getItem('alertaValidadesMostrado');
      const dataUltimoAlerta = localStorage.getItem('alertaValidadesData');
      const hoje = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
      
      console.log('[ALERTA VALIDADES] Verificando...', {
        alertaJaMostrado,
        dataUltimoAlerta,
        hoje,
        deveMostrar: !alertaJaMostrado || dataUltimoAlerta !== hoje
      });
      
      // Se não foi mostrado hoje OU é um novo dia, mostrar o alerta
      if (!alertaJaMostrado || dataUltimoAlerta !== hoje) {
        checkValidadesHoje();
      } else {
        console.log('[ALERTA VALIDADES] Já foi mostrado hoje');
        setLoading(false);
      }
    }, 1000); // Aguarda 1 segundo após o componente montar
    
    return () => clearTimeout(timer);
  }, []);

  const calcularDiasRestantes = (dataValidade) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const validade = new Date(dataValidade);
    validade.setHours(0, 0, 0, 0);
    const diffTime = validade - hoje;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const checkValidadesHoje = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.log('[ALERTA VALIDADES] Token não encontrado');
        setLoading(false);
        return;
      }

      console.log('[ALERTA VALIDADES] Buscando validades próximas...');
      
      // Usar endpoint otimizado que já filtra no backend
      const response = await axios.get(`${API_URL}/api/validades/hoje`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const expiramHoje = response.data;
      
      console.log('[ALERTA VALIDADES] Resultado:', {
        total: expiramHoje.length,
        produtos: expiramHoje.map(v => v.produto?.nome)
      });

      if (expiramHoje.length > 0) {
        setValidadesHoje(expiramHoje);
        setShow(true);
        // Marcar que o alerta foi mostrado hoje
        const hoje = new Date().toISOString().split('T')[0];
        localStorage.setItem('alertaValidadesMostrado', 'true');
        localStorage.setItem('alertaValidadesData', hoje);
        console.log('[ALERTA VALIDADES] Alerta exibido!');
      } else {
        console.log('[ALERTA VALIDADES] Nenhum produto com validade próxima');
      }
    } catch (error) {
      console.error('[ALERTA VALIDADES] Erro ao verificar:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    // Garantir que não mostra novamente hoje
    const hoje = new Date().toISOString().split('T')[0];
    localStorage.setItem('alertaValidadesMostrado', 'true');
    localStorage.setItem('alertaValidadesData', hoje);
  };

  if (loading || !show || validadesHoje.length === 0) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] animate-in fade-in duration-200">
      <div className="bg-background rounded-lg shadow-2xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-orange-500 to-red-500 text-white p-6 rounded-t-lg flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-3 rounded-full animate-pulse">
              <AlertTriangle className="h-8 w-8" />
            </div>
            <div>
              <h2 className="text-2xl font-bold">Atenção!</h2>
              <p className="text-white/90">Produtos com validade a expirar em breve</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            className="text-white hover:bg-white/20"
          >
            <X className="h-5 w-5" />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded">
            <p className="text-sm font-semibold text-orange-800">
              {validadesHoje.length} produto(s) com validade próxima do vencimento!
            </p>
            <p className="text-xs text-orange-700 mt-1">
              Verifique os produtos e registe quebras se necessário.
            </p>
          </div>

          <div className="space-y-3">
            {validadesHoje.map((validade, index) => {
              const diasRestantes = calcularDiasRestantes(validade.data_validade);
              const expiraHoje = diasRestantes === 0;
              const vencido = diasRestantes < 0;
              
              return (
                <Card key={validade.id || index} className="border-orange-200 bg-orange-50/30">
                  <CardContent className="p-4">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <Package className="h-5 w-5 text-orange-600" />
                          <h3 className="font-semibold text-lg">{validade.produto?.nome || 'Produto'}</h3>
                          {vencido && (
                            <span className="px-2 py-1 bg-red-100 text-red-700 text-xs font-bold rounded">
                              VENCIDO
                            </span>
                          )}
                          {expiraHoje && !vencido && (
                            <span className="px-2 py-1 bg-orange-100 text-orange-700 text-xs font-bold rounded animate-pulse">
                              EXPIRA HOJE
                            </span>
                          )}
                          {!expiraHoje && !vencido && diasRestantes <= 2 && (
                            <span className="px-2 py-1 bg-yellow-100 text-yellow-700 text-xs font-bold rounded">
                              {diasRestantes} {diasRestantes === 1 ? 'DIA' : 'DIAS'}
                            </span>
                          )}
                          {!expiraHoje && !vencido && diasRestantes > 2 && (
                            <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded">
                              {diasRestantes} dias
                            </span>
                          )}
                        </div>
                        <div className="space-y-1 text-sm text-muted-foreground">
                          <p><span className="font-medium">Loja:</span> {validade.loja}</p>
                          <p><span className="font-medium">Validade:</span> {new Date(validade.data_validade).toLocaleDateString('pt-PT')}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="bg-orange-100 border border-orange-300 rounded-lg px-4 py-2">
                          <p className="text-xs text-orange-700 font-medium">Quantidade</p>
                          <p className="text-2xl font-bold text-orange-600">{validade.quantidade}</p>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center pt-4 border-t">
            <p className="text-xs text-muted-foreground">
              Acesse a aba <span className="font-semibold">Validades</span> para registar quebras
            </p>
            <Button onClick={handleClose} className="bg-orange-600 hover:bg-orange-700">
              Entendi
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertaValidadesHoje;
